import {
    GET_PARTNER_DETAILS_REQUEST,
    GET_PARTNER_DETAILS_REQUEST_SUCCESS,
    GET_PARTNER_DETAILS_REQUEST_FAIL,
    GET_MEMBER_CHECK_REQUEST,
    GET_MEMBER_CHECK_REQUEST_SUCCESS,
    GET_MEMBER_CHECK_REQUEST_FAIL,
    POST_EVENT_LOG_REQUEST,
    POST_EVENT_LOG_REQUEST_SUCCESS,
    POST_EVENT_LOG_REQUEST_FAIL
} from "./../ActionTypes";
import axios from './../../config/axios';
import { ApiConfig } from "../../config/ApiConfig";

const token = localStorage.getItem('access_token');
const config = {
    headers: { 
        Authorization: `Bearer ${token}`,
        'X-ClientSecret':ApiConfig.clientSecret
    }
}

export const getPartnerDetails = (requestData) => {
    return dispatch => {
        dispatch({ type: GET_PARTNER_DETAILS_REQUEST });
        let endpoint = `${ApiConfig.getPartnerDetailsReqUrl}/${requestData}`;
        return axios.get(endpoint, config)
            .then(res => {
                return dispatch({ type: GET_PARTNER_DETAILS_REQUEST_SUCCESS, data: res.data.data, isFetching: false });
            })
            .catch(err => {
                const errorsList = err?.response?.data?.errors;
                const errorMessage = errorsList?.message && errorsList.message !== 'Validation Errors'
                    ? errorsList.message
                    : (err?.message || 'Sorry! something went wrong, please try again.');
                return dispatch({ type: GET_PARTNER_DETAILS_REQUEST_FAIL, isFetching: false, errorMessage });
            })
    }
}

export const checkMemberId = (requestData) => {
    return dispatch => {
        dispatch({ type: GET_MEMBER_CHECK_REQUEST });
        let endpoint = `${ApiConfig.verifyMemberReqUrl}`;
        
        return axios.post(endpoint, requestData, config)
            .then(res => {
                return dispatch({ type: GET_MEMBER_CHECK_REQUEST_SUCCESS, data:res.data.data, isFetching: false });
            })
            .catch(error => {
                let errorMsg = 'Sorry! something went wrong, please try again.';
                const errorsList = error?.response?.data?.errors;
                if (errorsList) {
                    if (errorsList.message !== 'Validation Errors') {
                        errorMsg = errorsList.message;
                    } else {
                        for (const key in errorsList.detail) {
                            if (errorsList.detail.hasOwnProperty(key)) {
                                if (typeof errorsList.detail === 'undefined') {
                                    errorMsg = errorsList.message;
                                } else {
                                    errorMsg = errorsList.detail[key];
                                }
                            }
                        }
                    }
                }
                return dispatch({ type: GET_MEMBER_CHECK_REQUEST_FAIL, hasError:true, errorMessage:errorMsg, isFetching: false });
            })
        }
}

export const logEvent = (requestData) => {
    return dispatch => {
        dispatch({ type: POST_EVENT_LOG_REQUEST });
        let endpoint = `${ApiConfig.eventLogUrl}`;
        
        return axios.post(endpoint, requestData, config)
            .then(res => {
                return dispatch({ type: POST_EVENT_LOG_REQUEST_SUCCESS, data:res.data.data, isFetching: false });
            })
            .catch(error => {
                let errorMsg = 'Sorry! something went wrong, please try again.';
                const errorsList = error?.response?.data?.errors;
                if (errorsList) {
                    if (errorsList.message !== 'Validation Errors') {
                        errorMsg = errorsList.message;
                    } else {
                        for (const key in errorsList.detail) {
                            if (errorsList.detail.hasOwnProperty(key)) {
                                if (typeof errorsList.detail === 'undefined') {
                                    errorMsg = errorsList.message;
                                } else {
                                    errorMsg = errorsList.detail[key];
                                }
                            }
                        }
                    }
                }
                return dispatch({ type: POST_EVENT_LOG_REQUEST_FAIL, hasError:true, errorMessage:errorMsg, isFetching: false });
            })
        }
}